import React from 'react';
import './style.scss';
import { ChevronLeft } from '@material-ui/icons';

const PageHeader = ({ text, history }) => {
    return (
        <div className='page-header'>
            <button onClick={e => { e.preventDefault(); history.goBack(); }} ><ChevronLeft /></button>
            {text}
        </div>
    );
};

export default PageHeader;
